import { useCallback, useRef } from "react";
import { isEqual } from "lodash";

// This allow using lodash's `isEqual` to check `useEffect` depencies have actually
// changed between two effect calls, which can avoid re-calling effects if their
// dependencies did not change.
//
export const useDependenciesDidChange = () => {
  const dependenciesRef = useRef({});

  return useCallback(
    dependencies =>
      Object.keys(dependencies).reduce((dependenciesChanged, dependencyName) => {
        const previousValue = dependenciesRef.current[dependencyName];
        const currentValue = dependencies[dependencyName];

        const dependencyDidChange = !isEqual(previousValue, currentValue);

        if (dependencyDidChange) {
          dependenciesRef.current[dependencyName] = currentValue;
        }

        return dependenciesChanged || dependencyDidChange;
      }, false),
    []
  );
};
